import React from 'react';

import './styles.css';

interface RoomWithRoomTypeProps {
  room: string;
  roomType: string;
}

const RoomWithRoomType = ({room, roomType}: RoomWithRoomTypeProps) => (
  <div className="RoomWithRoomType">
    <div className="RoomWithRoomType__room">{room}</div>
    <div className="RoomWithRoomType__roomType">{roomType}</div>
  </div>
);

export default RoomWithRoomType;
